import type { SnapshotSummary, UserDetail } from "./types";

type AcademicUser = Pick<UserDetail, "account" | "studentNumber" | "profile">;

export function isGraduateUser(user: AcademicUser): boolean {
  if (/研究生|硕士|博士/.test(String(user.profile.studentType || ""))) {
    return true;
  }
  const number = String(
    user.studentNumber || user.profile.studentNumber || user.account || "",
  ).trim();
  return /^11\d{13}$/.test(number);
}

export function userGradeSnapshot(
  user: AcademicUser & Pick<UserDetail, "snapshots">,
): SnapshotSummary | undefined {
  const resourceKey = isGraduateUser(user) ? "graduate:grades" : "grades";
  return user.snapshots.find(
    (snapshot) => snapshot.resourceKey === resourceKey,
  );
}

// Normalize only for rendering; reads and mutations retain the full source key.
export function academicResourceBase(resource: string): string {
  return resource.startsWith("graduate:")
    ? resource.slice("graduate:".length)
    : resource;
}
